import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useReservation} from 'context/reservation';
import {API} from '@chekin/api';

function useFetchEsimFeature() {
  const {housingId, data: reservation} = useReservation();
  const isAiraloEnabled = reservation?.airalo_settings?.airalo_enabled;

  const {data, isLoading} = useQuery({
    queryKey: [QUERY_CACHE_KEYS.esimFeature],
    queryFn: () => API.upselling.getUpsellingEsimFeature(),
    enabled: Boolean(housingId) && isAiraloEnabled,
  });

  return {
    isEsimEnabled: Boolean(
      isAiraloEnabled &&
        !isLoading &&
        housingId &&
        data?.housings_ids.includes(housingId),
    ),
    isLoading,
  };
}

export {useFetchEsimFeature};
